export const getQuarterValue = (quarter: number) => {
    return ["I", "II", "III", "IV"][quarter - 1] || "";
};
export const getQuarterValue = (quarter: number) => {
    return ["I", "II", "III", "IV"][quarter - 1] || "";
};
